export default __webpack_public_path__ + "static/210-215-6248bba3692b08939d72809b12dbef94.jpg";